module.exports = __webpack_public_path__ + "img/commission.736f96db.svg";